const BASE = process.env.VUE_APP_API || ''

const DEFAULTS = {
	method: 'GET',
	url: '/',
	headers: {
		'Content-Type': 'application/json',
	},
}

export const apiUrl = endpoint => BASE + '/admin' + endpoint

class APIError extends Error {
	constructor({ status, message }) {
		super(message)
		this.code = status
	}
}

async function req(options = {}) {
	// Send API request
	const { url, ...opts } = { ...DEFAULTS, ...options }
	const res = await fetch(apiUrl(url), opts)
	const body = await res.json()

	// Handle response
	if (res.ok) {
		return body
	} else {
		throw new APIError({
			status: res.status,
			message: body.message,
		})
	}
}

export default {
	get: url => req({ url }),
	post: (url, body) =>
		req({
			method: 'POST',
			url,
			body: JSON.stringify(body),
		}),
	patch: (url, body) =>
		req({
			method: 'PATCH',
			url,
			body: JSON.stringify(body),
		}),
	upload: (url, file) => {
		const headers = {}
		const body = new FormData()
		body.append('file', file)
		return req({
			method: 'POST',
			url,
			headers,
			body,
		})
	},
}
